module.exports = __webpack_public_path__ + "static/media/visibilitat-01.b0cdfd35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/visibilitat/visibilitat-01.svg
// module id = 781
// module chunks = 0